import { environment } from 'src/environment/environment';
import { Client } from 'typesense';

export const typesense = new Client({
  nodes: [
    {
      host: environment.typesenseProductDBDomain,
      port: 443,
      protocol: 'https',
    },
  ],
  apiKey: environment.typesenseProductDBApiKey,
});
